import React from 'react';
import { Link } from 'react-router-dom';
import { FooterCTA } from '../components/FooterCTA';
export function Magazin() {
  const products = [{
    title: 'ProVi System',
    description: 'Sistem complet de conducere antreprenorială implementat în 12 luni.',
    path: '/provisystem',
    image: 'https://cdn.magicpatterns.com/uploads/1oazmUNSMVFsvFr3YbPYQQ/ProVi_System_-_Magazin.png',
    tag: 'Implementare 12 Luni'
  }, {
    title: 'Training Personalizat',
    description: 'Aliniază-ți echipa și crește productivitatea cu un training dedicat.',
    path: '/trainingpersonalizat',
    image: 'https://cdn.magicpatterns.com/uploads/jx7RfNnrdNxJcKZA6MiKin/Training_Personalizat_-_Magazin.png',
    tag: 'Pentru Echipe'
  }, {
    title: 'Ședință Trimestrială',
    description: 'Planificare strategică pentru următorul trimestru alături de echipa ta.',
    path: '/sedintatrimestriala',
    image: 'https://cdn.magicpatterns.com/uploads/hoQJVqHk3xZLNdVDQKUxYw/Sedinta_Trimestriala_-_Magazin.png',
    tag: 'Planificare'
  }, {
    title: 'ProVi Sprint',
    description: 'Implementare accelerată în 12 săptămâni pentru rezultate rapide.',
    path: '/provisprint',
    image: 'https://cdn.magicpatterns.com/uploads/vTvhE1EfBEFwHdKebQ6B9a/ProVi_Sprint_-_Magazin.png',
    tag: 'Program 12 Săptămâni'
  }, {
    title: 'Workshop',
    description: 'Ieși din haosul operațional în 90 de zile. Sesiune intensivă de 2-3 ore.',
    path: '/workshop',
    image: 'https://cdn.magicpatterns.com/uploads/wWqi7248ZwgDhb48hEZ17T/Workshop_Intensiv_-_Magazin.png',
    tag: 'Sesiune Intensivă'
  }, {
    title: 'ProVi Toolkit',
    description: 'Instrumentele simple și clare cu care pui ordine în afacere singur.',
    path: '/provitoolkit',
    image: 'https://cdn.magicpatterns.com/uploads/mmxohDj4AezbmX67We4WuC/Toolkit_Provisystem_-_Magazin.png',
    tag: 'Produs Digital'
  }];
  return <div className="bg-[#09111F] min-h-screen pt-32 pb-0" data-id="element-478" data-mp="3c8ohoyd69ycw">
      {/* Header Section */}
      <section className="px-5 md:px-12 max-w-[1200px] mx-auto text-center mb-16" data-id="element-479" data-mp="1aj97tgf5ibm9">
        <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-4 py-2 rounded-full mb-8" data-id="element-480" data-mp="1ah6824o7544c">
          <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.15em] uppercase text-[#3B82F6]" data-id="element-481" data-mp="10lus5j11xqv0">
            SERVICII & OFERTE
          </span>
        </div>
        <h1 className="font-['Montserrat'] text-[clamp(32px,5vw,56px)] font-extrabold text-white mb-6 leading-[1.1] tracking-tight" data-id="element-482" data-mp="1ta0ci4o71dub">
          Alege programul potrivit
          <br data-id="element-483" data-mp="1y6r3vo5g7vv1" />
          pentru afacerea ta
        </h1>
        <p className="font-['Inter'] text-[19px] text-[rgba(255,255,255,0.7)] max-w-[700px] mx-auto leading-[1.6]" data-id="element-484" data-mp="1jcck3le28ifb">
          Fiecare ofertă este concepută pentru un alt punct de plecare. Dacă nu
          știi de unde să începi, programează mai întâi sesiunea gratuită de
          evaluare.
        </p>
      </section>

      {/* Grid Section */}
      <section className="px-5 md:px-12 max-w-[1200px] mx-auto mb-24" data-id="element-485" data-mp="cte8x55kvsu4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-486" data-mp="2r1ow3bjgdvy1">
          {products.map((product, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg flex flex-col transition-transform duration-300 hover:-translate-y-2 group" data-id="element-487" data-mp="2m3x6io6a6lx0" data-mpi={index}>
              {/* Image (clickable + zoom on hover) */}
              <Link to={product.path} className="relative aspect-[16/9] overflow-hidden block" data-id="element-488" data-mp="2w0id3dxy852y">
                <img src={product.image} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-489" data-mp="28ae6qytdlr89" />
              </Link>
              <div className="p-8 flex flex-col flex-grow" data-id="element-490" data-mp="2h6dhct81ooqa">
                <span className="self-start bg-[#EFF6FF] text-[#1D4ED8] font-['Montserrat'] text-[11px] font-bold tracking-wider uppercase px-3 py-1.5 rounded-full mb-4" data-id="element-491" data-mp="2ce3rteaudqoj">
                  {product.tag}
                </span>
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-3" data-id="element-492" data-mp="1kmo9vxk8cs4n">
                  {product.title}
                </h3>
                <p className="font-['Inter'] text-[16px] text-[#4B5563] mb-8 flex-grow leading-[1.6]" data-id="element-493" data-mp="22b8iigto0z5a">
                  {product.description}
                </p>
                <Link to={product.path} className="inline-flex justify-center items-center w-full font-['Montserrat'] text-[14px] font-bold bg-[#1D4ED8] text-white px-6 py-3.5 rounded-xl hover:bg-[#2563EB] transition-colors" data-id="element-494" data-mp="2799z8v3mcmdl">
                  Vezi detalii →
                </Link>
              </div>
            </div>)}
        </div>
      </section>

      <FooterCTA title="Nu știi ce ți se potrivește?" subtitle="Programează o sesiune gratuită de evaluare și te ajut să găsești drumul potrivit pentru afacerea ta." buttonText="Programează Sesiunea Gratuită" data-id="element-495" data-mp="2q0ksvk0qbd96" />
    </div>;
}